<template>
    <v-container fluid>
    <v-toolbar class="elevation-0" height="48px">
        <v-toolbar-title >Liste des mouvements</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="switchTab" outlined rounded small :color="'green'" @click="switchTab('21')">Ajouter<v-icon>mdi-playlist-edit</v-icon></v-btn>
    </v-toolbar>
    <v-data-table v-bind:headers="headers" :items="itemList" item-key="id" :search="search"
        items-per-page-text="Lignes par page" hide-default-header
        :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:top>
            <v-row class="rounded-lg ma-0 pa-0">
                <v-col cols="6" md="6" class="pa-1">
                <v-text-field append-icon="mdi-magnify" label="Recherche" outlined dense clearable single-line
                            hide-details v-model="search" class="pa-2 rounded-xl">
                </v-text-field>
                </v-col>
            </v-row>
        </template>
        <template v-slot:[`item.ass_sit_id`]="{ item }">
            <v-chip class="ma-2" color="primary" small>Site: {{ item.ass_sit_id }}</v-chip>
        </template>
        <template v-slot:[`item.ass_sta_id`]="{ item }">
            <v-chip class="ma-2" color="secondary" small>{{ item.ass_sta_id }}</v-chip>
        </template>
        <template v-slot:[`item.ass_departure_date`]="{ item }">
            <v-icon small class="mr-1">mdi-calendar</v-icon>{{ item.ass_departure_date }}
        </template>
        <template v-slot:[`item.ass_departure_time`]="{ item }">
            <v-icon small class="mr-1">mdi-clock-outline</v-icon>{{ item.ass_departure_time }}
        </template>
        <template v-slot:[`item.ass_id`]="{ item }">
            <v-icon v-if="item.ass_doc_id" left color='primary' title="Télécharger le compte rendu" @click="downloadVouch(item.ass_doc_id)">
                mdi-file-download
            </v-icon>
            <v-btn v-if="$root.$permissions.Assignment && $root.$permissions.Assignment.update" rounded :href="'/#/assignments/' + item.ass_id + ''" color="orange" elevation="0" dark small>
                <v-icon left small>mdi-pencil</v-icon> Fiche
            </v-btn>
        </template>
        <template v-slot:no-data>
        <v-alert :value="( !itemList.length )" color="error" icon="mdi-alert">
            Aucune assignation
        </v-alert>
        </template>
    </v-data-table>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useAssignmentStore } from '@/stores/assignment'
import { useDocumentStore } from '@/stores/document'

export default {
    name: 'assignments-list',
    props: [ 'sit_id', 'ass_sit_id_old', 'livestockId', 'switchTab' ],
    computed: {
        ...mapState(useAssignmentStore, {itemList: 'itemList' })
    },
    data: function () {
        return {
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
                { text: 'Site', value: 'ass_sit_id', align: 'left'},
                { text: 'Statut', value: 'ass_sta_id', align: 'left'},
                { text: 'Date départ', value: 'ass_departure_date', align: 'left'},
                { text: 'Heure départ', value: 'ass_departure_time', align: 'left'},
                { text: 'Action', value: 'ass_id', align: 'right'},
            ],
        }
    },
    async mounted () {
        let params  = '?per_page=false'
        params     += ( this.sit_id ) ? '&sit_id=' + this.sit_id : ''
        //params     += ( this.ass_sit_id_old ) ? '&ass_sit_id_old=' + this.ass_sit_id_old : ''
        params     += ( this.livestockId ) ? '&extended=withlivestock&ali_lst_id=' + this.livestockId : ''
        await this.fetchItems(params)
    },
    methods: {
        ...mapActions(useAssignmentStore, {fetchItems: 'fetchItems'}),
        ...mapActions(useDocumentStore, { downloadDocument: 'downloadItem' }),
        async downloadVouch(docId){
            const report = await this.downloadDocument( docId )
            this.$download(report.blob, 'cr_visite', report.contentType)
        },
    },
}
</script>